// extracted by mini-css-extract-plugin
export default {"adquirirAhora":"CustomButton_adquirirAhora__COGnp","boton":"CustomButton_boton__b8F1l"};